






import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class trComponent extends Vue {
    @Prop() item;
}
